// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PendingOrders from '../pages/pos/PendingOrders';
import PosInvoiceJazira from '../pages/sys/PosInvoiceJazira';
 
const PosRoutes = () => {
  return (
    <Routes>
      <Route path="/pending-orders" element={<PendingOrders />} />
        <Route path="/jaziira/:route/:id" element={<PosInvoiceJazira />} />
      
       </Routes>
  );
};

export default PosRoutes;
